function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import gettext from 'js-utils/gettext';
import { formatUrl } from 'url-lib';
import IconButton from '../iconButton/IconButton';
import EBPropTypes from 'js-utils/prop-types';
import { UTM_OPTION_PROPTYPE } from './constants';
import { openUrl } from './utils';
import MailFillChunkySvg from '../iconography/icons/MailFillChunky';

var _getMailToUrl = function _getMailToUrl(eventName, eventUrl, utmOptions) {
  var emailOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var subject = gettext('You\'re invited to %(eventName)s', {
    eventName: eventName
  });
  var body = formatUrl(eventUrl, utmOptions);

  if (emailOptions.subject) {
    subject = emailOptions.subject;
  }

  if (emailOptions.body) {
    body = emailOptions.body;
  }

  return formatUrl('mailto:', {
    subject: subject,
    body: body
  });
};

var EmailShare =
/*#__PURE__*/
function (_React$Component) {
  _inherits(EmailShare, _React$Component);

  function EmailShare() {
    _classCallCheck(this, EmailShare);

    return _possibleConstructorReturn(this, _getPrototypeOf(EmailShare).apply(this, arguments));
  }

  _createClass(EmailShare, [{
    key: "_handleButtonClick",
    value: function _handleButtonClick() {
      var _this$props = this.props,
          eventName = _this$props.eventName,
          eventUrl = _this$props.eventUrl,
          onClick = _this$props.onClick,
          utmOptions = _this$props.utmOptions,
          emailOptions = _this$props.emailOptions;

      var url = _getMailToUrl(eventName, eventUrl, utmOptions, emailOptions);

      if (onClick) {
        onClick();
      }

      openUrl(url);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("span", {
        className: "eds-l-pad-right-1",
        "data-spec": "email-share-box-container"
      }, React.createElement(IconButton, {
        iconType: React.createElement(MailFillChunkySvg, null),
        title: gettext('Share by Email'),
        onClick: this._handleButtonClick.bind(this)
      }));
    }
  }]);

  return EmailShare;
}(React.Component);

_defineProperty(EmailShare, "propTypes", {
  /**
   * Event's id
   */
  eventId: PropTypes.string.isRequired,

  /**
   * Event's name
   */
  eventName: PropTypes.string.isRequired,

  /**
   * Event's url
   */
  eventUrl: PropTypes.string.isRequired,

  /**
   * Server's url
   */
  serverUrl: PropTypes.string.isRequired,

  /**
   * Boolean prop to know if we're on a mobile device or not
   */
  isMobile: PropTypes.bool,

  /**
   * Function that onClick of one of the share options, passes
   * back an id of the clicked option
   */
  onClick: PropTypes.func,

  /**
   * utmOptions configured for this shareType
   */
  utmOptions: UTM_OPTION_PROPTYPE,

  /**
   * affiliate_code configured for this shareType
   */
  trackingCode: PropTypes.string,

  /**
   * Configurable copy options
   * for prefilling the email
   */
  emailOptions: PropTypes.shape({
    //Defaults to the formatted url of the shared entity
    bodyCopy: EBPropTypes.translation,
    //Defaults to "You're invited to {eventName}"
    subjectCopy: EBPropTypes.translation
  })
});

export { EmailShare as default };